import { useContext } from 'react';

import MultiSelect, { MultiSelectOption } from '@/components/common/MultiSelect';
import { ConfigContext } from '@/Contexts/ConfigContext';
import { CountryProps } from '@/models/Country';

export function CountrySelect({
  selectedCountries,
  onCountriesChange,
}: {
  selectedCountries: number[];
  onCountriesChange: (countryIds: number[]) => void;
}) {
  const { allCountries } = useContext(ConfigContext);
  return (
    <MultiSelect
      id='select-country'
      options={allCountries?.map(
        (c: CountryProps) =>
          ({
            key: c.name,
            name: c.name,
            value: c.id.toString(),
          })
      )}
      label='Countries'
      selectedValues={selectedCountries.map(String)}
      setSelectedValues={(ids: string[]) => onCountriesChange(ids.map(Number))}
      required
    />
  );
}
